export default "__VITE_ASSET__QEAYeJBb__"